<div class="search-detail">
  <div class="detail-header">
    <div>
      <p class="breadcrumb">Search / Conversation Detail</p>
      <h1 class="title">Conversation Detail</h1>
      <p class="subtitle">Review the full session, metadata, and analysis placeholders.</p>
    </div>
    <a class="back-link" routerLink="/library/search">Back to search</a>
  </div>

  <div class="id-row" *ngIf="conversationId">
    <span class="label">Path</span>
    <span class="value">/library/search/{{ conversationId }}</span>
  </div>

  <div *ngIf="loading" class="state-card">Loading conversation details…</div>
  <div *ngIf="error && !loading" class="state-card error">{{ error }}</div>

  <ng-container *ngIf="!loading && !error">
    <div class="summary-grid">
      <div class="summary-card">
        <h3>Started</h3>
        <p>{{ stats.startTime ? (stats.startTime | date:'medium') : '—' }}</p>
      </div>
      <div class="summary-card">
        <h3>Ended</h3>
        <p>{{ stats.endTime ? (stats.endTime | date:'medium') : '—' }}</p>
      </div>
      <div class="summary-card">
        <h3>Model(s)</h3>
        <p *ngIf="stats.models.length; else noModels">
          {{ stats.models.join(', ') }}
        </p>
        <ng-template #noModels>
          <span class="muted">No model metadata recorded.</span>
        </ng-template>
      </div>
      <div class="summary-card">
        <h3>Message Count</h3>
        <p>{{ stats.messageCount }}</p>
        <p class="meta">Tokens: {{ stats.totalTokens }}</p>
      </div>
      <div class="summary-card">
        <h3>Roles</h3>
        <div class="role-grid">
          <span class="role-pill">User: {{ stats.roleCounts.user || 0 }}</span>
          <span class="role-pill">Assistant: {{ stats.roleCounts.assistant || 0 }}</span>
          <span class="role-pill">System: {{ stats.roleCounts.system || 0 }}</span>
        </div>
      </div>
      <div class="summary-card">
        <h3>Conversation</h3>
        <p class="meta">Title: {{ truncateConversationTopic(conversation?.title || 'Conversation') }}</p>
        <p class="meta">ID: {{ conversation?.id }}</p>
      </div>
    </div>

    <div class="analysis-panel">
      <div class="analysis-header">
        <h2>Background Agent Analysis</h2>
        <span class="engine">ChatGPT 5.2</span>
      </div>
      <div class="analysis-grid">
        <div>
          <h4>IQ Estimate</h4>
          <p class="muted">Not inferred. This app does not estimate IQ.</p>
        </div>
        <div>
          <h4>Personality</h4>
          <p class="muted">Not inferred. Sensitive personality profiling is disabled.</p>
        </div>
        <div>
          <h4>Education Level</h4>
          <p class="muted">Not inferred. Education level predictions are unavailable.</p>
        </div>
        <div>
          <h4>Vowels vs Consonants (User)</h4>
          <p>{{ letterStats.vowels }} vowels · {{ letterStats.consonants }} consonants</p>
          <p class="meta">{{ letterStats.totalLetters }} total letters analyzed</p>
        </div>
      </div>
    </div>

    <div class="messages-section">
      <div class="section-header">
        <h2>Conversation Markdown</h2>
        <p class="muted">Each block is collapsible, similar to closing code in an editor.</p>
      </div>

      <div class="message-grid">
        <details class="message-card" *ngFor="let msg of messages; let i = index" open>
          <summary>
            <div class="summary-content">
              <span class="summary-index">#{{ i + 1 }}</span>
              <span class="summary-role">{{ msg.role }}</span>
              <span class="summary-time">{{ msg.timestamp | date:'short' }}</span>
            </div>
            <span class="summary-toggle">Toggle</span>
          </summary>
          <div class="message-body">
            <div class="message-meta">
              <span>Model: {{ msg.modelDisplayName || msg.modelId || '—' }}</span>
              <span>Tokens: {{ msg.tokens || 0 }}</span>
              <span *ngIf="msg.image">Image attached</span>
            </div>
            <div *ngIf="msg.content" class="markdown prism-content" [innerHTML]="convertMarkdown(msg.content)" appCodeHighlight></div>
            <div *ngIf="msg.image" class="image-wrap">
              <img [src]="msg.image" alt="Conversation attachment" />
            </div>
          </div>
        </details>
      </div>
    </div>
  </ng-container>
</div>
